import React from "react";
import { SidebarData } from "./SidebarData";
import SubMenu from "./SubMenu";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";

const Sidebar = () => {
  const userPermissions = useRecoilValue(permissionsSelector);

  //Filter Main Menu and Sub Menu per permission
  const permittedReports = SidebarData.filter((reports) =>
    userPermissions.includes(reports.permission)
  );

  return (
    <div className="w-full rounded-2xl">
      {permittedReports.map((item, index) => {
        return <SubMenu item={item} key={index} />;
      })}
    </div>
  );
};

export default Sidebar;
